import { Plus } from '@good/icons';
import { Button, Popover } from '@good/ui/core';
import CustomViewPopover from 'common-components/custom-views/popover/CustomViewPopover';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BookingView } from 'stores/rematch/models/types/bookings-store';
import { IRootDispatch, IRootState } from 'stores/rematch/root-store';
import { CustomViewsModalType } from 'utilities/enum-utils';
import { useChangeView } from '../books-view-context/use-change-view';

interface AddViewButtonProps {
  openBookingViewModal: (type: CustomViewsModalType) => void;
  bookingViews: BookingView[];
  showPopover: boolean;
  onChangePopover: (visible: boolean) => void;
}

export const AddViewButton = ({
  openBookingViewModal,
  bookingViews,
  showPopover,
  onChangePopover,
}: AddViewButtonProps) => {
  const displayedBookingListingTabs = useSelector(
    (state: IRootState) => state.bookingsStore.displayedBookingListingTabs,
  );
  const dispatch = useDispatch<IRootDispatch>();
  const setBookingListingActiveTab = dispatch.bookingsStore.setBookingListingActiveTab;
  const changeView = useChangeView();

  const onChangeDisplayedViews = useCallback(
    async (views: BookingView[]) => {
      const view = views[views.length - 1];
      changeView(view, views, {
        reset: true,
        caller: 'AddViewButton.onChangeDisplayedViews',
        refreshDisplayedViews: true,
        takeSnapshot: true,
      });
    },
    [changeView],
  );

  const pageViews = bookingViews.filter(
    (view) => !displayedBookingListingTabs.find((displayedView) => displayedView.customViewId === view.customViewId),
  );

  return (
    <Popover opened={showPopover} onChange={onChangePopover}>
      <Popover.Target>
        <Button variant='default' leftSection={<Plus />} onClick={() => onChangePopover(true)}>
          Add
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <CustomViewPopover
          pageViews={pageViews}
          displayedPageListingTabs={displayedBookingListingTabs}
          onCreateNewView={() => openBookingViewModal(CustomViewsModalType.CREATE)}
          onDisplayTab={onChangePopover}
          setDisplayedPageListingTabs={onChangeDisplayedViews}
          setPageListingActiveTab={setBookingListingActiveTab}
        />
      </Popover.Dropdown>
    </Popover>
  );
};
